import { Injectable } from '@angular/core';

import { selectAuth2State, State } from '@app/store/reducers';
import { CognitoUser } from '@cco/model';
import { selectCurrentUser, selectCurrentUserPrivileges } from '@core/auth2/store/auth2.reducer';
import { select, Store } from '@ngrx/store';

@Injectable()
export class RedirectorGuardService  {
  currentUser: CognitoUser = null;
  userPrivileges: string[] = null;

  constructor(private store: Store<State>) {
    this.store
      .pipe(select(selectAuth2State), select(selectCurrentUser))
      .subscribe(currentUser => (this.currentUser = currentUser));
    this.store
      .pipe(select(selectAuth2State), select(selectCurrentUserPrivileges))
      .subscribe(userPrivileges => (this.userPrivileges = userPrivileges));
  }

  canActivate(): boolean {
    /*
    if (this.currentUser && this.userPrivileges.includes('READ_TENANTS')) {
      console.log(`User has privilege READ_TENANTS.  Redirecting to /app/global-admin ...`);
      // this.router.navigateByUrl('/app/global-admin');
      return false;
    } else if (this.currentUser && !this.userPrivileges.includes('READ_TENANTS')) {
      console.log('User does not have privilege READ_TENANTS.  Redirecting to /app/trucks ...');
      this.router.navigateByUrl('/app/trucks');
      return false;
    }
    */

    /*
        if (!this.currentUser) {
          this.router.navigateByUrl('/app/auth2/authenticate');
          return false;
        }
        */

    return true;
  }
}
